import { useAuth } from '@/zustand/auth-store';
import { Navigate, Outlet } from 'react-router';

const ProtectedRoute = () => {
  const accessToken = useAuth(state => state.accessToken);
  const hasHydrated = useAuth(state => state.hasHydrated);

  if (!hasHydrated) {
    return null;
  }

  if (!accessToken) {
    return <Navigate to={'/login'} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
